import { CSSObject } from "@mui/material/styles";

export type ButtonSize = "extraSmall" | "small" | "medium" | "large";

// Single source of truth for button size styles. Consumed by the theme
// `styleOverrides` (size classes) and by the responsive Button wrapper, which
// re-applies these styles per breakpoint via `sx`.
// Please follow guidelines https://www.figma.com/design/zzvO7fdaTfLvgTSrb6ypCs/wikifolio-UI-Library?node-id=0-847&p=f&m=dev
export const BUTTON_SIZE_STYLES: Record<ButtonSize, CSSObject> = {
    extraSmall: {
        paddingInline: "16px",
        minWidth: "32px",
        height: "32px",
        fontWeight: 600,
        lineHeight: "24px",
    },
    small: {
        paddingInline: "16px",
        minWidth: "40px",
        height: "40px",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "24px",
    },
    medium: {
        paddingInline: "24px",
        minWidth: "48px",
        height: "48px",
        fontSize: "16px",
        fontWeight: 600,
    },
    large: {
        paddingInline: "32px",
        minWidth: "56px",
        height: "56px",
        fontSize: "16px",
        fontWeight: 600,
    },
};
